// extracted by mini-css-extract-plugin
export default {"ResultsCounter":"ResultsCounter__ResultsCounter___uS47L"};